import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { NavbarService } from 'src/app/services/navbar.service'

@Component({
    selector: 'app-navigation-bar',
    templateUrl: './navigation-bar.component.html',
    styleUrls: ['./navigation-bar.component.scss'],
})
export class NavigationBarComponent implements OnInit {
    featureChevron: boolean = false
    companyChevron: boolean = false
    isShowPannel: boolean = false
    register: boolean = true

    constructor(private router: Router, public navbarService: NavbarService) { }

    ngOnInit(): void {
    }

    featuresToggle() {
        this.featureChevron = !this.featureChevron
    }

    companyToggle() {
        this.companyChevron = !this.companyChevron
    }

    pannelToggle() {
        this.isShowPannel = !this.isShowPannel
    }
}